module.exports = __webpack_public_path__ + "img/PRNT_01_mono_AE_00000.8f160974.png";